@if (!isSelfService()) {
    @if (showHeader()) {
        <app-header></app-header>
    }
    <div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
        <div
            [class]="
                !maintenanceMode
                    ? 'tw-mx-6 tw-mt-[80px] tw-flex-grow tw-rounded-xl tw-bg-white'
                    : ''
            ">
            <router-outlet></router-outlet>
        </div>
        <app-global-footer
            class="tw-z-10"
            [footerVisibility]="false"></app-global-footer>
    </div>
} @else {
    <div
        class="tw-h-svh tw-flex tw-flex-col"
        #contentArea>
        <div class="tw-w-svh tw-h-screen tw-overflow-hidden tw-bg-white">
            <router-outlet></router-outlet>
        </div>
        <app-selfservice-footer
            [footerVisibility]="true"></app-selfservice-footer>
    </div>
}

<ngx-spinner
    bdColor="rgba(0, 0, 0, 0.5)"
    size="medium"
    color="#ffffff"
    type="ball-scale-multiple"
    [fullScreen]="true">
</ngx-spinner>
